if (!customElements.get('featured-blog-carousel')) {
  customElements.define(
    'featured-blog-carousel',
    class FeaturedBlogCarousel extends HTMLElement {
      connectedCallback() {
        if (this.sliderInstance) return;
        if (this.dataset.enableCarousel !== 'true') return;

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.wrapper = this.querySelector('.featured-blog__items');
        if (!this.section || !this.wrapper) return;

        // --f-column-gap only resolves on .f-grid elements, which we deliberately
        // don't emit in carousel mode. Read the raw breakpoint vars declared by
        // the .f-grid--gap-* classes instead.
        const styles = window.getComputedStyle(this);
        const gap = (name, fallback) => {
          const px = parseFloat(styles.getPropertyValue(name).trim().replace('rem', '')) * 10;
          return Number.isFinite(px) ? px : fallback;
        };
        const gapMobile = gap('--f-column-gap-mobile', 12);
        const gapMd = gap('--f-column-gap-md', gapMobile);
        const gapLg = gap('--f-column-gap-lg', gapMd);
        const gapXl = gap('--f-column-gap-xl', gapLg);

        const perMobile = parseFloat(this.dataset.slidesMobile) || 1.5;
        const perTablet = parseFloat(this.dataset.slidesTablet) || 2.2;
        const perDesktop = parseFloat(this.dataset.slidesDesktop) || 3.2;

        this.sliderInstance = new window.FoxTheme.Carousel(
          this,
          {
            slidesPerView: perMobile,
            spaceBetween: gapMobile,
            loop: false,
            threshold: 2,
            watchOverflow: true,
            navigation: {
              nextEl: this.section.querySelector('.swiper-button-next'),
              prevEl: this.section.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
              768: { slidesPerView: perTablet, spaceBetween: gapMd },
              1024: { slidesPerView: perDesktop, spaceBetween: gapLg },
              1280: { slidesPerView: perDesktop, spaceBetween: gapXl },
            },
            mousewheel: {
              enabled: true,
              forceToAxis: true,
            },
          },
          [FoxTheme.Swiper.Mousewheel]
        );
        this.sliderInstance.init();
        this.handleAccessibility();
      }

      handleAccessibility() {
        FoxTheme.a11y.getFocusableElements(this).forEach((element) => {
          element.addEventListener('focusin', (event) => {
            if (event.relatedTarget === null) {
              element.blur();
              return;
            }
            const slide = element.closest('.swiper-slide');
            if (!slide) return;
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });
      }

      disconnectedCallback() {
        if (this.isConnected) return;
        if (!this.sliderInstance) return;
        this.sliderInstance.slider.destroy(true, true);
        this.sliderInstance = null;
      }
    }
  );
}
